"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackCollapsedBlockClick = trackCollapsedBlockClick;
var _analytics = require("@cian/analytics");
function trackCollapsedBlockClick(type) {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'click_sopr',
    label: 'different_price_more',
    useLastProducts: true,
    page: {
      extra: {
        type
      }
    }
  });
}